import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersAmountEntered
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from and to
 * selects having values selected and the amount input filled
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersAmountEntered(props) {
    // Initalize all the model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // Then updating the from, to and amount properties of the transfer.
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .submit();
    
    // Return the TransfersPage passing the data variable
    return <TransfersPage data={ data } />
}